<!-- (onSelectionChanged)="selectOnSomeText($event)"  -->
<!-- <p> {{ inputControl.valueChanges | async }} </p> -->
<!-- <quill-editor
  spell-check="false"
  (onEditorCreated)="onEditorCreated($event)"
  [formControl]="inputControl"
  placeholder="Hãy viết gì đó..."
  class="qe-mh block w-11/12 mx-auto text-center"
></quill-editor> -->

<!-- <div id="editorjs"></div> -->

<!-- fontname: { inline: 'span', classes: '%value', toggle: false, styles: { fontFamily: '%value' }, clear_child_styles: true },
      fontsize: { inline: 'span', classes: '%value', toggle: false, styles: { fontSize: '%value' }, clear_child_styles: true }, -->
<!-- font_size_formats: '8pt=pt-8 10pt=pt-10 12pt=pt-12 14pt=pt-14 16pt=pt-16 18pt=pt-18 24pt=pt-24 36pt=pt-36 48pt=pt-48', -->
<!-- formats: {
      p: { block: 'p', attributes: { id: (Math.random()).toString(32).substr(2,5) }  },
      h1: { block: 'h1', attributes: { id: (Math.random()).toString(32).substr(2,5) }  },
      h2: { block: 'h2', attributes: { id: (Math.random()).toString(32).substr(2,5) }  },
      h3: { block: 'h3', attributes: { id: (Math.random()).toString(32).substr(2,5) }  },
      alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'text-left' },
      aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'text-center' },
      alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'text-right' },
      alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video', classes: 'text-justify' },
      bold: { inline: 'span', classes: 'font-bold' },
      italic: { inline: 'span', classes: 'italic' },
      underline: { inline: 'span', classes: 'underline', exact: true },
      strikethrough: { inline: 'del' },
      forecolor: { inline: 'span', classes: '%value', styles: { color: '%value' } },
      hilitecolor: { inline: 'span', classes: '%value', styles: { backgroundColor: '%value' } },
      fontname: { inline: 'span', classes: '%value',  toggle: false},
      fontsize: { inline: 'span', classes: '%value',  toggle: true, clear_child_styles: true, wrapper: true},
      lineheight: { selector: 'h1,h2,h3,h4,h5,h6,p,li,td,th,div', classes: '%value', styles: { lineHeight: '%value' }},
      fontsize_class: { inline: 'span', attributes: { class: '%value' }},
      blockquote: { block: 'blockquote', wrapper: true, remove: 'all' },
      subscript: { inline: 'sub' },
      superscript: { inline: 'sup' },
      code: { inline: 'code' }
    }, -->
<!-- entity_encoding: 'raw', => not encoding data   -->

<p *ngIf="!editable" class="italic text-red-500  mb-1">Note*: Vì đây là truyện dự thi nên không thể chỉnh sửa</p>
<editor [disabled]="!editable" class="" [style.height]="'65vh'" initialValue="Ngày xửa ngày xưa..." [formControl]="inputControl"
  apiKey="6mbyb7ijnxu3hqmvt7a3mery2hn7dtj8rypzt35o843vr6m1" [init]="{
    browser_spellcheck: true,
    entity_encoding: 'raw',
    plugins: 'image codesample preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons',
    language: 'vi',
    language_url: '/frontend-assets/langs/vi.js',
    content_css: '/tiny-mce-editor.css',
    font_family_formats: 'sans-serif=Helvetica, Arial, sans-serif',
    placeholder: 'Kéo thả hoặc Ctrl + V hoặc paste để dán ảnh, ảnh động chỉ hỗ trợ webp, không hỗ trợ video',
    toolbar: 'image codesample undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
    quickbars_selection_toolbar: 'bold italic | quicklink h1 h2 h3 blockquote',
    quickbars_insert_toolbar: false,
    contextmenu: false,
    toolbar_sticky: true,
    toolbar_sticky_offset: isSmallScreen ? 102 : 108,
    autosave_ask_before_unload: true,
    autosave_interval: '30s',
    autosave_prefix: '{path}{query}-{id}-',
    autosave_restore_when_empty: false,
    autosave_retention: '2m',
    max_height: 1200,
    min_height: 600,
    codesample_languages: [
    { text: 'HTML/XML', value: 'markup' },
    { text: 'JavaScript', value: 'javascript' },
    { text: 'Typescript', value: 'typescript' },
    { text: 'CSS', value: 'css' },
    { text: 'SCSS', value: 'scss' },
    { text: 'PHP', value: 'php' },
    { text: 'Ruby', value: 'ruby' },
    { text: 'Python', value: 'python' },
    { text: 'Graphql', value: 'graphql' },
    { text: 'SQL', value: 'sql' },
    { text: 'Java', value: 'java' },
    { text: 'C', value: 'c' },
    { text: 'C#', value: 'csharp' },
    { text: 'C++', value: 'cpp' },
    { text: 'Swift', value: 'swift' },
    { text: 'Kotlin', value: 'kotlin' },
    ],
    images_upload_handler: data.imageUploadHandler,
    file_picker_callback: data.pickFileCallback,
    setup: data.setup
   }"></editor>